import { render, staticRenderFns } from "./paper-list.vue?vue&type=template&id=d13e989e&scoped=true&"
import script from "./paper-list.vue?vue&type=script&lang=js&"
export * from "./paper-list.vue?vue&type=script&lang=js&"
import style0 from "./paper-list.vue?vue&type=style&index=0&id=d13e989e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13e989e",
  null
  
)

export default component.exports